/** Public, build-time config. Secrets never go here (see .env.example). */
export const env = {
  supabaseUrl: import.meta.env.VITE_SUPABASE_URL as string | undefined,
  supabaseKey: import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY as string | undefined,
  sentryDsn: import.meta.env.VITE_SENTRY_DSN as string | undefined,
  appEnv: (import.meta.env.VITE_APP_ENV as string | undefined) ?? import.meta.env.MODE,
  version: (import.meta.env.VITE_APP_VERSION as string | undefined) ?? 'dev',
}

export const isConfigured = Boolean(env.supabaseUrl && env.supabaseKey)
